import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Flux from '../../../flux/Flux';
import TopCamsGrid from '../../TopCams/TopCamsGrid';
import Constants from '../../../flux/Constants';
import LogoLoader from '../../Loader/LogoLoader';

const TILES_PER_PAGE = 30;

const ACTOR_COLLECTIONS = {
	[Flux.Constants.ActorId.LEXY_ROXX]: { collectionName: 'lexy_girls' },
	[Flux.Constants.ActorId.LENI_FETISCH]: { collectionName: 'leni_girls' },
	[Flux.Constants.ActorId.LIAENGEL]: { collectionName: 'lia_girls' },
	[Flux.Constants.ActorId.LANA_GREY]: { collectionName: 'lana_girls' },
	[Flux.Constants.ActorId.LUCY_CAT]: { collectionName: 'lucy_girls', firstModels: 20 },
};

const ActorProfileTopCams = (props) => {
	const { actorId, isMobile } = props;
	const [actors, setActors] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [isLoadMore, setIsLoadMore] = useState(false);
	const [total, setTotal] = useState(0);

	const actorConfig = ACTOR_COLLECTIONS[actorId];
	const defaultArgs = {
		hiddenCategories: true,
		firstModels: TILES_PER_PAGE + 3,
		offsetModels: 0,
		collectionNames: [actorConfig.collectionName],
	};

	if (!actorConfig) return null;

	const gridRef = useRef(null);

	useEffect(() => {
		Flux.Actor.addActorTopCamsChangeListener(onTopCamsChange);
		return () => {
			Flux.Actor.removeActorTopCamsChangeListener(onTopCamsChange);
		};
	}, [isLoadMore]);

	useEffect(() => {
		Flux.Browser.addWindowScrollListener(onScroll);
		return function () {
			Flux.Browser.removeWindowScrollListener(onScroll);
		};
	}, [isLoadMore, actors, total]);

	const loadTopCams = () => {
		const args = {
			...defaultArgs,
			firstModels: actorConfig.firstModels || defaultArgs.firstModels,
		};
		const collectionName = args.collectionNames.collectionName;
		const topCams = Flux.Actor.getActorTopCams(collectionName);
		const topCamsTotal = Flux.Actor.getActorTopCamsTotal(collectionName);

		if (topCams) {
			setActors(topCams);
			setTotal(topCamsTotal);
			setIsLoading(false);
		} else {
			Flux.Actor.loadActorTopCams(args);
		}
	};

	const onTopCamsChange = (collectionName) => {
		const actorTopCams = Flux.Actor.getActorTopCams(collectionName);
		const actorTopCamsTotal = Flux.Actor.getActorTopCamsTotal(collectionName);
		if (isLoadMore) {
			setActors([...actors, ...actorTopCams]);
			setIsLoadMore(false);
		} else if (actorTopCams) {
			setActors(actorTopCams);
			setTotal(actorTopCamsTotal);
			setIsLoading(false);
		}
	};

	const getTile = (models) => {
		if (actorId === Flux.Constants.ActorId.LUCY_CAT) {
			const lana = [...actors].find((model) => model.id === Flux.Constants.ActorId.LANA_GREY);
			if (lana) {
				models = models.filter((model) => model.id !== Flux.Constants.ActorId.LANA_GREY);
				models.unshift(lana);
			}
		}
		return models.map((cam, idx) => {
			const useBigUrl =
				idx < 3 &&
				(Flux.Browser.getWindowSize().width < Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm ||
					Flux.Browser.getWindowSize().width > Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md);
			cam.previewPicture = useBigUrl ? cam.avatar.bigUrl : cam.avatar.url;
			cam.ranking = idx + 1;
			return cam;
		});
	};

	const getType = () => {
		switch (actorId) {
			case Flux.Constants.ActorId.LEXY_ROXX:
				return Constants.TopCams.Categories.LEXY_GIRLS;
			case Flux.Constants.ActorId.LENI_FETISCH:
				return Constants.TopCams.Categories.LENI_GIRLS;
			case Flux.Constants.ActorId.LUCY_CAT:
				return Constants.TopCams.Categories.LUCY_GIRLS;
			case Flux.Constants.ActorId.LANA_GREY:
				return Constants.TopCams.Categories.LANA_GIRLS;
			case Flux.Constants.ActorId.LIAENGEL:
				return Constants.TopCams.Categories.LIA_GIRLS;
		}
	};

	const onScroll = () => {
		if (!isLoadMore && total > actors.length && window.innerHeight - gridRef.current.getBoundingClientRect().bottom > 50) {
			loadMore(actors.length);
		}
	};

	const loadMore = (offset) => {
		setIsLoadMore(true);
		const args = {
			...defaultArgs,
			firstModels: TILES_PER_PAGE,
			offsetModels: offset,
		};
		Flux.Actor.loadActorTopCams(args);
	};

	return (
		<div className="h-min-height-100vh " ref={gridRef}>
			<TopCamsGrid
				loadData={loadTopCams}
				type={getType()}
				actors={getTile(actors)}
				isMobile={isMobile}
				loading={isLoading}
				showOnlinefilter={false}
				useShortHeadline={true}
				total={total}
			/>
			{isLoadMore && <LogoLoader isRelative={true} />}
		</div>
	);
};

ActorProfileTopCams.propTypes = {
	actorId: PropTypes.number,
	isMobile: PropTypes.bool,
};

export default ActorProfileTopCams;
